module.exports = __webpack_public_path__ + "static/footerlogo-e4fd5b3ff47e78e7107595164954c510.png";